import { z } from 'zod';

export const SEARCH_HIT_TYPES = [
  'journal',
  'check',
  'deposit',
  'invoice',
  'account',
  'contact',
  'bank_transaction',
] as const;
export type SearchHitType = (typeof SEARCH_HIT_TYPES)[number];

export const searchQuerySchema = z.object({
  q: z.string().trim().min(1).max(100),
  limit: z.coerce.number().int().min(1).max(25).default(8),
});
export type SearchQuery = z.infer<typeof searchQuerySchema>;

export interface SearchHit {
  type: SearchHitType;
  id: string;
  title: string;
  subtitle: string | null;
  amount: string | null;
  date: string | null;
  /** For contacts: vendor | customer | employee | other — drives which page to open. */
  contactType: string | null;
}

export interface SearchGroup {
  type: SearchHitType;
  label: string;
  hits: SearchHit[];
}

export interface SearchResponse {
  query: string;
  groups: SearchGroup[];
  total: number;
}
